import { useRef, useState } from "react";

export default function useAsyncAction() {
  const active = useRef(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  async function run(task) {
    if (active.current) return;
    active.current = true;
    setPending(true);
    setError("");
    try {
      await task();
    } catch (err) {
      console.error("Request failed:", err);
      setError(err.message || "Unable to complete the request. Please try again.");
    } finally {
      active.current = false;
      setPending(false);
    }
  }
  return { pending, error, run, clearError: () => setError("") };
}
